export default "__VITE_ASSET__DLE7OGeg__"